module.exports = __webpack_public_path__ + "img/hiking_1413_4.f8a6f2c6.jpg";